import Model from "~/models/_Model";

export default class CommunicationDescription extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/mtss";
  }

  // Set the resource route of the model
  resource() {
    return "communication-descriptions";
  }

  relations() {
    return {};
  }

  primaryKey() {
    return "code";
  }

  /**
   * Helper Methods
   */

  /**
   * Helper Attributes
   */
}
